import { Box, Button, LinearProgress, Typography } from '@mui/material'
import { PlannedExpertiseTransmissionProps } from './_props'
import useStyles from './_styles'
import { RefreshRoundedIcon } from '../../../assets/icons/icons'
import AnnouncementIcon from '@mui/icons-material/Announcement'

const TEXTS = {
    sending: {
        title: (
            <>
                Merci de patienter,
                <br />
                transmission en cours...
            </>
        ),
        subtitle: (
            <>
                Suivez l'évolution du statut de votre demande
                <br />
                depuis la section historique
            </>
        ),
    },
    error: {
        title: (
            <>
                Oups, quelque chose a empêché <br />
                la transmission de la demande
            </>
        ),
        subtitle: (
            <>
                Veuillez ne pas fermer cette fenêtre et relancer la
                <br />
                transmission. Si le problème persiste, contactez le support
                <br />
                technique de TokTokDoc
            </>
        ),
    },
    warning: {
        title: <>Le requérant n'a plus de courriel sécurisé de renseigné</>,
        subtitle: (
            <>
                L’adresse sécurisée du requérant a été supprimée de l’annuaire santé. Veuillez vérifier si un autre
                courriel est disponible dans sa fiche, ou le contacter directement.
            </>
        ),
    },
} as const

// Linear progress bar inspired by material ui
function LinearProgressWithLabelAndValue({ value, isError = false }: { value: number; isError?: boolean }) {
    const classes = useStyles()
    const label = isError ? 'Erreur' : `${Math.round(value)}%`
    const displayValue = isError ? 100 : value
    const labelClass = isError ? classes.progressLabelError : classes.progressLabelSuccess
    const barClass = isError ? classes.progressBarError : classes.progressBarSuccess

    return (
        <Box className={classes.progressContainer}>
            <Box className={classes.progressContent}>
                <Box className={classes.progressLabelWrapper}>
                    <Typography className={`${classes.progressLabel} ${labelClass}`}>{label}</Typography>
                </Box>
                <Box className={classes.progressBarWrapper}>
                    <LinearProgress
                        variant="determinate"
                        value={displayValue}
                        className={`${classes.progressBar} ${barClass}`}
                    />
                </Box>
            </Box>
        </Box>
    )
}

export default function PlannedExpertiseTransmission({ status, progress, onRetry }: PlannedExpertiseTransmissionProps) {
    const classes = useStyles()
    if (status === 'idle') return null
    const isFailed = status === 'error' || status === 'warning'
    const { title, subtitle } = TEXTS[isFailed ? status : 'sending']

    return (
        <Box className={classes.transmissionContainer}>
            {status === 'warning' ? (
                <Box className={classes.warningIconWrapper}>
                    <AnnouncementIcon className={classes.warningIcon} />
                </Box>
            ) : (
                <Box className={classes.transmissionProgressWrapper}>
                    <LinearProgressWithLabelAndValue value={progress} isError={status === 'error'} />
                </Box>
            )}
            <Typography className={isFailed ? classes.transmissionErrorTitle : classes.transmissionTitle}>
                {title}
            </Typography>
            <Typography className={classes.transmissionSubtitle}>{subtitle}</Typography>
            {status === 'error' && (
                <Button onClick={onRetry} variant="contained" className={classes.retryButton}>
                    <RefreshRoundedIcon />
                    Relancer la transmission
                </Button>
            )}
        </Box>
    )
}
